export function dateNoSeconds(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes());
}

export function dateClearedTime(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}
